import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import { isAuthenticated } from "./helpers/auth";
import store from "./store";
import CreateUrl from "./views/CreateUrl.vue";
import Terms from "./views/Terms.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base:
    process.env.NODE_ENV === "development"
      ? process.env.BASE_URL + "promoters"
      : process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { allowAnonymous: true }
    },
    {
      path: "/create-url",
      name: "create-url",
      component: CreateUrl,
      meta: { allowAnonymous: true }
    },
    {
      path: "/terms",
      name: "terms",
      component: Terms,
      meta: { allowAnonymous: true }
    },
    {
      path: "/sale-links",
      name: "sale-links",
      component: () =>
        import(/* webpackChunkName: "sale-links" */ "./views/SaleLinks.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/security",
      name: "security",
      component: () =>
        import(/* webpackChunkName: "security" */ "@/views/Security.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/planner-features",
      name: "planner-features",
      component: () =>
        import(
          /* webpackChunkName: "planner-features" */ "@/views/PlannerFeatures.vue"
        ),
      meta: { allowAnonymous: true }
    },
    {
      path: "/buyer-features",
      name: "buyer-features",
      component: () =>
        import(
          /* webpackChunkName: "buyer-features" */ "@/views/BuyerFeatures.vue"
        ),
      meta: { allowAnonymous: true }
    },
    {
      path: "/how-it-works",
      name: "how-it-works",
      component: () =>
        import(/* webpackChunkName: "how-it-works" */ "@/views/HowItWorks.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/blog",
      name: "blog",
      component: () =>
        import(/* webpackChunkName: "blog" */ "@/views/Blog.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/about-us",
      name: "about-us",
      component: () =>
        import(/* webpackChunkName: "about-us" */ "@/views/About.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/faq",
      name: "faq",
      component: () =>
        import(/* webpackChunkName: "help-center" */ "@/views/FAQ.vue"),
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: "/contact-us",
      name: "contact-us",
      component: () =>
        import(/* webpackChunkName: "contact-us" */ "@/views/Contact.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/terms",
      name: "terms",
      component: () =>
        import(/* webpackChunkName: "terms" */ "@/views/Terms.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: () =>
        import(/* webpackChunkName: "privacy-policy" */ "@/views/Privacy.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/refunds",
      name: "refunds",
      component: () =>
        import(/* webpackChunkName: "refunds" */ "@/views/Refunds.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/cookies",
      name: "cookies",
      component: () =>
        import(/* webpackChunkName: "cookies" */ "@/views/Cookies.vue"),
      meta: { allowAnonymous: true }
    },
    {
      path: "/accessibility-statement",
      name: "accessibility-statement",
      component: () =>
        import(
          /* webpackChunkName: "accessibility-statement" */ "@/views/AccessibilityStatement.vue"
        ),
      meta: { allowAnonymous: true }
    },
    {
      path: "/dashboard",
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "./views/Dashboard.vue"),
      children: [
        {
          path: "",
          name: "dashboard",
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ "./views/Dashboard/CurrentEvents.vue"
            )
        },
        {
          path: "past",
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ "./views/Dashboard/PastEvents.vue"
            )
        }
      ]
    },
    {
      path: "/profile",
      name: "profile",
      component: () =>
        import(/* webpackChunkName: "profile" */ "@/views/Profile.vue")
    },
    {
      path: "/my-events",
      name: "my-events",
      redirect: "/dashboard"
    },
    {
      path: "/financials/:url",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "event-financials" */ "./views/Financials.vue"
        ),
      children: [
        {
          path: "",
          name: "event-financials",
          redirect: "transactions"
        },
        {
          path: "commissions",
          component: () =>
            import(
              /* webpackChunkName: "financials" */ "./views/Financials/Commissions.vue"
            )
        },
        {
          path: "transactions",
          component: () =>
            import(
              /* webpackChunkName: "financials" */ "./views/Financials/Transactions.vue"
            )
        }
      ]
    },
    {
      path: "/event-buyers-list/:event",
      name: "event-buyers-list",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "event-buyers-list" */ "./views/EventTicketsList.vue"
        )
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () =>
        import(
          /* webpackChunkName: "notifications" */ "@/views/Notifications.vue"
        )
    },
    {
      path: "/verify",
      name: "verify",
      meta: { allowAnonymous: true },
      component: () =>
        import(/* webpackChunkName: "verify" */ "@/views/Verify.vue")
    },
    {
      path: "/sale-list/:event",
      name: "sale-list",
      component: () => import("./views/SaleLists.vue")
    },
    {
      path: "*",
      name: "not-found",
      component: () =>
        import(/* webpackChunkName: "404" */ "@/views/NotFound.vue")
    }
  ],

  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  function proceed() {
    let user = store.state.user;
    if (user) {
      if (user.nmp_confirm_terms_updated && user.promoter_link) {
        next();
        return;
      }
      if (!user.nmp_confirm_terms_updated) {
        if (to.name !== "terms") {
          next("/terms");
        } else {
          next();
        }

        // if (this.$route.name !== "terms") {
        //   this.$router.push("/terms");
        // }
      } else if (!user.promoter_link) {
        if (to.name !== "create-url") {
          next("/create-url");
        } else {
          next();
        }

        // if (this.$route.name !== "create-url") {
        //   this.$router.push("/create-url");
        // }
      }
    } else next();
  }
  try {
    if (!to.meta.allowAnonymous && !isAuthenticated()) {
      next({
        path: "/",
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      if (store.state.user.email) {
        proceed();
      } else {
        store.watch(
          () => store.getters.getUser(),
          function() {
            if (store.getters.getUser()) {
              proceed();
            }
          }
        );
        next();
      }
    }
  } catch (err) {
    console.log(err);
  }
});

router.afterEach((to, from) => {
  const toParts = to.path.split("/");
  const fromParts = from.path.split("/");

  // this handles page with child paths, not 100% sure this is fool proof
  if (
    toParts.length > 1 &&
    fromParts.length > 1 &&
    toParts[1] === fromParts[1]
  ) {
    return;
  }

  // reset navbar meta when navigating
  store.commit("setTitle", "");
  store.commit("setSubtitle", "");
  store.commit("setHelpVideoSrc", "");
});

export default router;
